import * as React from "react"

export const ArrowLeftIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="m7.373 12.75 5.17 5.17a.7.7 0 0 1 .22.521.74.74 0 0 1-.236.532.78.78 0 0 1-.527.225.7.7 0 0 1-.527-.225l-6.34-6.34A.83.83 0 0 1 4.877 12a.83.83 0 0 1 .256-.633l6.34-6.34a.72.72 0 0 1 .514-.212.75.75 0 0 1 .54.212.74.74 0 0 1 .232.535q0 .302-.232.534L7.373 11.25H18.75q.32 0 .535.216A.73.73 0 0 1 19.5 12a.73.73 0 0 1-.215.535.73.73 0 0 1-.535.215z"
    />
  </svg>
)
